import { cn, ClassValue } from "@networx/utils/tailwind/cn";
import { SlotsToClasses } from "@nextui-org/react";

export default function CloseXIcon({ className, classNames, strokeWidth }: Props) {
  return (
    <svg
      className={cn("size-4", className, classNames?.base)}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        className={cn(classNames?.path)}
        d="M5 5L19 19M5 19L19 5"
        stroke="black"
        strokeWidth={strokeWidth ?? "2"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

  );
}

interface Props extends Pick<React.SVGProps<SVGSVGElement>, "strokeWidth"> {
  className?: ClassValue;
  classNames?: SlotsToClasses<"base" | "path">
}
